import { Select } from "chakra-react-select";
import { FormikProps } from "formik";
import { useMemo } from "react";
import { chakraStyles } from "../../../theme";
import { wellLevelsSitesReference } from "../../../types/wellLevelsData";
import { WellLevelViewFormValues } from "../../../types/wellLevelsForm";

export function SelectWellLevelsSites({ formik }: { formik: FormikProps<WellLevelViewFormValues> }) {
  const options = useMemo(
    () => Object.entries(wellLevelsSitesReference).map(([key, value]) => ({ label: value.label, value: key })),
    [],
  );

  return (
    <Select
      size="md"
      placeholder="Select Sites"
      options={options}
      isMulti
      onChange={(x) => {
        formik.setFieldValue(
          "sites",
          x.map((y: any) => y.value),
        );
        formik.handleSubmit();
      }}
      value={options.filter((x: any) => formik.values.sites.includes(x.value))}
      colorScheme="brand"
      chakraStyles={chakraStyles}
    />
  );
}
